module.exports = __webpack_public_path__ + "static/img/titar.eacedfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/entry/img/titar.png
// module id = h6ra
// module chunks = 1